import {
  Button,
  ButtonGroup,
  Drawer,
  DrawerBody,
  DrawerCloseButton,
  DrawerContent,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  FormControl,
  FormErrorMessage,
  FormHelperText,
  FormLabel,
  Input,
  Select,
  Table,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import { AddRaceResult } from "api/secureApi.ts";
import { GetCookie } from "api/jwt";

export default ({ isOpen, onClose, btnRef, raceResults }) => {
  return (
    <Drawer
      isOpen={isOpen}
      size={"md"}
      placement="right"
      onClose={onClose}
      finalFocusRef={btnRef}
    >
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton paddingTop={3} />
        <DrawerHeader>All results</DrawerHeader>
        <DrawerBody>
          <Table size={"sm"}>
            <Thead>
              <Tr>
                <Th>Position</Th>
                <Th>Name</Th>
                <Th>Score</Th>
              </Tr>
            </Thead>
            <Tbody>
              {raceResults &&
                raceResults.map((result, i) => (
                  <Tr>
                    <Td>{i + 1}</Td>
                    <Td>{result.name}</Td>
                    <Td>{result.score}</Td>
                  </Tr>
                ))}
            </Tbody>
          </Table>
        </DrawerBody>
        <DrawerFooter>
          <Button variant="outline" mr={3} onClick={onClose}>
            Close
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
};
